import { shopifyService } from "../../services";
import { customToast } from "../../shared/utility";
import { custom, failure, success } from "./actionsUtilities";
import {
  defaultGridState,
  inventoryConstants,
  shopifyConstants,
  systemConstants,
  toastType,
} from "../../constants";
import { inventoryActions } from "./inventory.action";
import { storeActions } from "./store.action";
import { companyActions } from "./company.action";

//------ Get Shopify Presets
const getShopifyPresets = (storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.GET_SHOPIFY_PRESETS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .getShopifyPresets(storeId)
      .then(
        (response) => {
          dispatch(success(response, shopifyConstants.GET_SHOPIFY_PRESETS));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.GET_SHOPIFY_PRESETS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//------ Create Shopify Presets
const createShopifyPreset = (storeId, data, toggleAddShopifyPresetModal) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.CREATE_SHOPIFY_PRESET,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .createShopifyPreset(storeId, data)
      .then(
        (response) => {
          toggleAddShopifyPresetModal();
          dispatch(getShopifyPresets(storeId));
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(failure([], shopifyConstants.GET_SHOPIFY_PRESETS));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.CREATE_SHOPIFY_PRESET,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//------ Update Shopify Presets
const updateShopifyPreset = (storeId, data, toggleAddShopifyPresetModal) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.UPDATE_SHOPIFY_PRESET,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .updateShopifyPreset(storeId, data)
      .then(
        (response) => {
          toggleAddShopifyPresetModal();
          dispatch(getShopifyPresets(storeId));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.UPDATE_SHOPIFY_PRESET,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//------ Update Shopify Presets
const createProductMappingObject = (
  storeId,
  data,
  toggleAddShopifyPresetModal,
  callBack = () => {}
) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.UPDATE_SHOPIFY_PRESET,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .createProductMappingObject(storeId, data)
      .then(
        (response) => {
          dispatch(
            inventoryActions.setProductShopifySettings({
              marginType: {
                ...inventoryConstants.MARGIN_TYPE_GLOBAL,
                isDefault: false,
              },
              marginObject: response,
            })
          );
          callBack(response);
          toggleAddShopifyPresetModal();
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.UPDATE_SHOPIFY_PRESET,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//------ Delete Shopify Presets
const deleteShopifyPreset = (storeId, data) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.DELETE_SHOPIFY_PRESET,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .deleteShopifyPreset(storeId, data)
      .then(
        (response) => {
          dispatch(getShopifyPresets(storeId));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.DELETE_SHOPIFY_PRESET,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateGlobalShopifyPreset = (
  storeId,
  data,
  toggleShopifyMappingModal
) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.UPDATE_GLOBAL_SHOPIFY_PRESET,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .updateShopifyPreset(storeId, data)
      .then(
        (response) => {
          toggleShopifyMappingModal();
          dispatch(getShopifyPresets(storeId));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.UPDATE_GLOBAL_SHOPIFY_PRESET,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getShopifyMappingsById = (storeId, id) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .getShopifyMappingsById(storeId, id)
      .then(
        (response) => {
          dispatch(
            success(
              {
                marginType: {
                  ...inventoryConstants.MARGIN_TYPE_GLOBAL,
                  isDefault: false,
                },
                marginObject: response,
              },
              inventoryConstants.SET_PRODUCT_SHOPIFY_MAPPING
            )
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const emptyShopifyProductSettings = (data = {}) => {
  return (dispatch) => {
    dispatch(success(data, inventoryConstants.SET_PRODUCT_SHOPIFY_MAPPING));
  };
};

//-------Get shopify orders
const getShopifyOrders = (storeId, gridState) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.GET_SHOPIFY_ORDERS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .getShopifyOrders(storeId, gridState)
      .then(
        (response) => {
          dispatch(success(response, shopifyConstants.GET_SHOPIFY_ORDERS));
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(failure([], shopifyConstants.GET_SHOPIFY_ORDERS));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.GET_SHOPIFY_ORDERS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateShopifyOrderStatus = (
  storeId,
  data,
  gridState,
  toggleOrderDetailsModal = false
) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.UPDATE_SHOPIFY_ORDER_STATUS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .updateShopifyOrderStatus(storeId, data)
      .then(
        (response) => {
          if (gridState === shopifyConstants.NOTIFICATION_MODAL) {
            dispatch(getShopifyOrderNotificationModalDetails(storeId, data.id));
            return;
          }

          if (toggleOrderDetailsModal) {
            toggleOrderDetailsModal();
          }
          dispatch(getShopifyOrders(storeId, gridState));
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.UPDATE_SHOPIFY_ORDER_STATUS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const updateShopifyOrderCustomer = (
  storeId,
  data,
  shopifyOrdersCallBackConfig = {
    gridState: defaultGridState,
    callBackFuction: () => {},
  }
) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.UPDATE_SHOPIFY_ORDER_STATUS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .updateShopifyOrderCustomer(storeId, data)
      .then(
        (response) => {
          shopifyOrdersCallBackConfig?.callBackFuction(response);
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.UPDATE_SHOPIFY_ORDER_STATUS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get shopify product tags
const getShopifyProductTags = (storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.GET_SHOPIFY_PRODUCT_TAGS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .getShopifyProductTags(storeId)
      .then(
        (response) => {
          dispatch(
            success(response, shopifyConstants.GET_SHOPIFY_PRODUCT_TAGS)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(failure([], shopifyConstants.GET_SHOPIFY_PRODUCT_TAGS));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.GET_SHOPIFY_PRODUCT_TAGS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

//-------get shopify theme templates
const getShopifyThemeTemplates = (storeId) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.GET_SHOPIFY_THEME_TEMPLATES,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .getShopifyThemeTemplates(storeId)
      .then(
        (response) => {
          dispatch(
            success(response, shopifyConstants.GET_SHOPIFY_THEME_TEMPLATES)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(failure([], shopifyConstants.GET_SHOPIFY_THEME_TEMPLATES));
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.GET_SHOPIFY_THEME_TEMPLATES,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const getShopifyOrderNotificationModalDetails = (
  storeId,
  orderId,
  refundedItemIds
) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.GET_SHOPIFY_ORDER_NOTIFICATION_MODAL_DETAILS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .getShopifyOrderById(storeId, orderId)
      .then(
        (response) => {
          dispatch(
            success(
              { ...response, refundedItemIds },
              shopifyConstants.GET_SHOPIFY_ORDER_NOTIFICATION_MODAL_DETAILS
            )
          );
          dispatch(setIsShowShopifyOrderNotificationModal(true));
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            failure(
              {},
              shopifyConstants.GET_SHOPIFY_ORDER_NOTIFICATION_MODAL_DETAILS
            )
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.GET_SHOPIFY_ORDER_NOTIFICATION_MODAL_DETAILS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const setIsShowShopifyOrderNotificationModal = (value) => {
  return (dispatch) => {
    dispatch(
      custom(value, shopifyConstants.TOGGLE_SHOPIFY_ORDER_NOTIFICATION_MODAL)
    );
  };
};

const resetShopifyStateToEmpty = () => {
  return (dispatch) => {
    dispatch({ type: shopifyConstants.RESET_SHOPIFY_TO_EMPTY });
  };
};

const getEligibleShopifyLocations = (companyId) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.GET_ELIGIBLE_SHOPIFY_LOCATIONS,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .getEligibleShopifyLocations(companyId)
      .then(
        (response) => {
          dispatch(
            success(response, shopifyConstants.GET_ELIGIBLE_SHOPIFY_LOCATIONS)
          );
        },
        (error) => {
          customToast(error, toastType.ERROR);
          dispatch(
            failure([], shopifyConstants.GET_ELIGIBLE_SHOPIFY_LOCATIONS)
          );
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.GET_ELIGIBLE_SHOPIFY_LOCATIONS,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const assignExistingShopifyLocation = (storeId, locationId, companyId) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.SET_SHOPIFY_CONNECTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .assignExistingShopifyLocation(storeId, locationId)
      .then(
        () => {
          dispatch(storeActions.getUpdatedCurrentStoreDetails(storeId));
          if (companyId) {
            dispatch(getEligibleShopifyLocations(companyId));
            dispatch(companyActions.getCurrentStoreCompanyDetails(companyId));
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.SET_SHOPIFY_CONNECTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

const createShopifyLocation = (storeId, companyId) => {
  return (dispatch) => {
    dispatch(
      custom(
        shopifyConstants.SET_SHOPIFY_CONNECTION,
        systemConstants.SPINNER_ACTIVATE
      )
    );
    shopifyService
      .createShopifyLocation(storeId)
      .then(
        () => {
          dispatch(storeActions.getUpdatedCurrentStoreDetails(storeId));
          if (companyId) {
            dispatch(getEligibleShopifyLocations(companyId));
            dispatch(companyActions.getCurrentStoreCompanyDetails(companyId));
          }
        },
        (error) => {
          customToast(error, toastType.ERROR);
        }
      )
      .finally(() => {
        dispatch(
          custom(
            shopifyConstants.SET_SHOPIFY_CONNECTION,
            systemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const shopifyActions = {
  getShopifyOrders,
  getShopifyPresets,
  createShopifyPreset,
  updateShopifyPreset,
  deleteShopifyPreset,
  getShopifyProductTags,
  getShopifyMappingsById,
  getShopifyThemeTemplates,
  updateShopifyOrderStatus,
  resetShopifyStateToEmpty,
  updateShopifyOrderCustomer,
  updateGlobalShopifyPreset,
  createProductMappingObject,
  emptyShopifyProductSettings,
  setIsShowShopifyOrderNotificationModal,
  getShopifyOrderNotificationModalDetails,
  getEligibleShopifyLocations,
  assignExistingShopifyLocation,
  createShopifyLocation,
};
